// Kicks off the MSAL redirect login when the user is not authenticated, while
// showing a calm centered spinner. Used by RequireAuth as the unauthenticated
// fallback and mounted at app entry.
// V1.14: bietet zusätzlich den E-Mail-OTP-Login als Alternative an. Wählt der
// Nutzer diesen, wird der Entra-Redirect unterdrückt und das OTP-Formular gezeigt.
import { useEffect, useState } from 'react'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { Icon } from '../components/icons'
import { login } from '../auth/authActions'
import { authEnabled, otpEnabled } from '../auth/msalConfig'
import { useBranding } from '../branding/useBranding'
import { OtpLogin } from '../auth/otp/OtpLogin'

export default function LoginRedirect() {
  const isAuthenticated = useIsAuthenticated()
  const { inProgress } = useMsal()
  // V1.14: App-Name aus Branding (greift pre-auth, da BrandingProvider global gemountet).
  const { appName } = useBranding()
  const [otpMode, setOtpMode] = useState(false)
  useEffect(() => {
    // Only start a login when MSAL is completely idle. Firing loginRedirect while
    // an interaction (startup / handleRedirect / login) is still in progress throws
    // "interaction_in_progress" and drives a redirect loop (dashboard flashes, then
    // bounces back to the Microsoft sign-in page).
    // Im OTP-Modus NICHT zu Entra weiterleiten.
    if (!otpMode && authEnabled && !isAuthenticated && inProgress === InteractionStatus.None) void login()
  }, [isAuthenticated, inProgress, otpMode])

  if (otpMode) {
    // Nach erfolgreichem OTP-Login lädt ein voller Reload /api/me mit dem neuen
    // Token und RequireAuth lässt den Nutzer durch.
    return <OtpLogin onAuthenticated={() => window.location.assign('/')} onCancel={() => setOtpMode(false)} />
  }

  if (!authEnabled) {
    return (
      <div className="vitals" style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', background: 'var(--cream)' }}>
        <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 40px 80px' }}>
          <div style={{ textAlign: 'center', maxWidth: 360 }}>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--surface)', border: '1px solid var(--line)',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 22, color: 'var(--ink-50)',
              boxShadow: 'var(--shadow-sm)' }}>
              <Icon.spark size={26} />
            </div>
            <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--woodland)', letterSpacing: '-0.3px', marginBottom: 6 }}>{appName}</div>
            <div style={{ fontSize: 17, fontWeight: 600, color: 'var(--woodland)', letterSpacing: '-0.3px' }}>Microsoft-Login ist nicht konfiguriert</div>
            <p style={{ fontSize: 13.5, color: 'var(--ink-50)', marginTop: 8 }}>Bitte wende dich an deine Administratorin oder deinen Administrator.</p>
            {otpEnabled && (
              <button type="button" className="vt-btn vt-btn-primary" style={{ justifyContent: 'center', marginTop: 18 }} onClick={() => setOtpMode(true)}>
                Mit E-Mail-Code anmelden
              </button>
            )}
          </div>
        </main>
      </div>
    )
  }

  return (
    <div className="vitals" style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', background: 'var(--cream)' }}>
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 40px 80px' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--surface)', border: '1px solid var(--line)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 22, color: 'var(--viridian)',
            boxShadow: 'var(--shadow-sm)' }}>
            <Icon.spark size={26} />
          </div>
          <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--woodland)', letterSpacing: '-0.3px', marginBottom: 6 }}>{appName}</div>
          <div style={{ fontSize: 17, fontWeight: 600, color: 'var(--woodland)', letterSpacing: '-0.3px' }}>Anmeldung…</div>
          <p style={{ fontSize: 13.5, color: 'var(--ink-50)', marginTop: 8 }}>Du wirst zu Microsoft weitergeleitet.</p>
          {otpEnabled && (
            <button type="button" className="vt-btn vt-btn-ghost" style={{ justifyContent: 'center', marginTop: 18, fontSize: 13 }} onClick={() => setOtpMode(true)}>
              Mit E-Mail-Code anmelden
            </button>
          )}
        </div>
      </main>
    </div>
  )
}
